import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getOfferUsps} from "../../offer/utils/get_offer_usps";

const DISTANCE_USP_PATTERN = /^(.*?):\s*(\d+(?:[.,]\d+)?)\s*([^\d\s|]+)\s*$/u;

const serializeUspLabel = (label: string): string => {
    const trimmedLabel = label.trim();
    const distanceUspMatch = trimmedLabel.match(DISTANCE_USP_PATTERN);

    if (!distanceUspMatch) {
        return trimmedLabel;
    }

    const [, name, distance, unit] = distanceUspMatch;

    return `${name.trim()}:${distance}${unit}`;
};

export const getAmplitudeOfferUsp = (offer: IOfferBoxOffer): string | null => {
    const usps = getOfferUsps(offer);

    if (!usps.length) {
        return null;
    }

    return usps.map(({label}) => serializeUspLabel(label)).join("|");
};
import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getOfferUsps} from "../../offer/utils/get_offer_usps";

const DISTANCE_USP_PATTERN = /^(.*?):\s*(\d+(?:[.,]\d+)?)\s*([^\d\s|]+)\s*$/u;

const serializeUspLabel = (label: string): string => {
    const trimmedLabel = label.trim();
    const distanceUspMatch = trimmedLabel.match(DISTANCE_USP_PATTERN);

    if (!distanceUspMatch) {
        return trimmedLabel;
    }

    const [, name, distance, unit] = distanceUspMatch;

    return `${name.trim()}:${distance}${unit}`;
};

export const getAmplitudeOfferUsp = (offer: IOfferBoxOffer): string | null => {
    const usps = getOfferUsps(offer);

    if (!usps.length) {
        return null;
    }

    return usps.map(({label}) => serializeUspLabel(label)).join("|");
};
